import React, { Component } from "react";
import { compose } from "redux";

import _ from "underscore";

import CircularProgress from "@material-ui/core/CircularProgress";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";

import SavelendActions from "./shared/Savelend.Actions";
import LoanstepActions from "./shared/Loanstep.Actions";

import UserBlockInfo from "./overview/UserBlockInfo";
import Impersonate from "./overview/Impersonate";

import { usersConnector } from "../../../services/users/connectors/Users.Connector";
import { getMainEmail } from "../../../utilities/contact.info.helpers";
import { BackendButton } from "../../../auth/BackendButton";

import "./Users.scss";

class UsersComponent extends Component {
  componentDidMount() {
    const { params } = this.props;

    if (params.id) {
      this.props.getUsers(params.id);
    }

    this.setState({ params });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { params } = this.props;

    if (params.id !== nextProps.params.id) {
      if (nextProps.params.id) {
        this.props.getUsers(nextProps.params.id);
      }
    }
  }

  handleChangeTab = (event, newValue) => {
    this.props.showAccount(newValue);
  };

  render() {
    let isLoading = this.props.users.fetching;

    return (
      <div className="body-height content-padding">
        {isLoading ? <CircularProgress /> : this.getDisplay()}
      </div>
    );
  }

  getDisplay = () => {
    let id = this.props.params.id;

    return this.props.users.currentUser ? (
      <div
        className={`body-height ${this.props.users.currentUser.DebtRestructuringInfo == null ? "" : "borrower-in-debt-restructuring"}`}
      >
        <h3>{this.props.users.currentUser.Domain}</h3>
        <UserBlockInfo currentUser={this.props.users.currentUser} />
        {this.props.users.currentUser.DebtRestructuringInfo !== null ? (
          <div>
            {this.props.users.currentUser.DebtRestructuringInfo.Announcement}
          </div>
        ) : undefined}
        <Tabs
          value={this.props.users.currentUser.Domain}
          onChange={this.handleChangeTab}
        >
          <Tab label="Loanstep - Show borrower" value="Loanstep" />
          <Tab label="Savelend - Show investor" value="Savelend" />
        </Tabs>
        {this.props.users.currentUser.Domain === "Loanstep" && (
          <React.Fragment>
            <div style={{ padding: "10px 0" }}>
              <div style={{ display: "flex" }}>
                <Impersonate currentUser={this.props.users.currentUser} />
                <BackendButton
                  label={"Backend"}
                  url={`${"/loanstep/borrowers/" + this.props.users.currentUser.SSN}`}
                />
              </div>
              <ProfileSwap
                currentUser={this.props.users.currentUser}
                data={this.props.users.data}
                showAccount={this.props.showAccount}
              />
              <LoanstepActions userId={id} />
            </div>
            {this.props.users.currentUser.Domain === "Loanstep"
              ? this.props.children
              : undefined}
          </React.Fragment>
        )}
        {this.props.users.currentUser.Domain === "Savelend" && (
          <React.Fragment>
            <div style={{ padding: "10px 0" }}>
              <div style={{ display: "flex" }}>
                <Impersonate
                  currentUser={this.props.users.currentUser}
                  savelend={true}
                />
                <BackendButton
                  label={"Backend"}
                  url={`${"/savelend/investors/by-guid/" + this.props.users.currentUser.Id}`}
                />
              </div>
              <ProfileSwap
                currentUser={this.props.users.currentUser}
                data={this.props.users.data}
                showAccount={this.props.showAccount}
              />
              <SavelendActions userId={id} />
            </div>
            {this.props.users.currentUser.Domain === "Savelend"
              ? this.props.children
              : undefined}
          </React.Fragment>
        )}
      </div>
    ) : this.props.users.fetchError || !this.props.users.currentUser ? (
      <div className="body-height "> User not found</div>
    ) : (
      <div className="body-height "> Loading users view...</div>
    );
  };
}

const ProfileSwap = ({ currentUser, data, showAccount }) => {
  const profilesPerDomain = _.filter(data, (item) => {
    return item.Domain === currentUser.Domain;
  });

  // Get display name for each profile
  // 1. If either SSN or Org data is present use those (bankid swedish users)
  // 2. If none of above is available it means this is user for EU who didn't identify yet (use email in this case)
  // 3. If for some reason email is not available just use Id so it doesn't crash
  const getProfileDisplayName = (item) => {
    if (item.SSN || item.OrgIdentityData)
      return <span>{item.SSN || item.OrgIdentityData.OrgNumber}</span>;
    else if (item.EmailData.Emails.length > 0) {
      const email = getMainEmail(item.EmailData);
      return <span>{email.EmailAddress}</span>;
    }
    return <span>{item.Id}</span>;
  };

  if (profilesPerDomain.length > 1)
    return (
      <TextField
        size="small"
        variant="outlined"
        select
        id="ProfilesPerDomain"
        label="Profiles per domain"
        style={{ marginTop: "28px" }}
        value={currentUser.Id}
        onChange={(event) => {
          showAccount("", event.target.value);
        }}
      >
        {profilesPerDomain.map((item, index) => {
          return (
            <MenuItem
              value={item.Id}
              key={`ProfilesPerDomain-dropdown_${index}`}
            >
              {getProfileDisplayName(item)}
            </MenuItem>
          );
        })}
      </TextField>
    );
  else return null;
};

export const User = compose(usersConnector)(UsersComponent);
